import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import Button from "@edaz/edazkit/Button";
import { observer } from "mobx-react-lite";
import React from "react";
import { Alert } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FormLabel from "controls/formLabel";
import { translateGeneral } from "utils/localizations";
import type DistributorRefundsViewModel from "viewModels/timeCharges/distributors/distributorRefunds/distributorRefundsViewModel";
import FilterView from "../../../common/filter";

export interface DistributorRefundsFilterProps {
  vm: DistributorRefundsViewModel;
}

const DistributorRefundsFilter = observer((props: DistributorRefundsFilterProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <div className="row" style={{ position: "relative", zIndex: 3 }}>
        {vm.isDeleteAllowed && (
          <div className="col-12 col-lg-4 order-lg-3">
            <div className="d-flex justify-content-end mt-lg-5">
              <Button
                onClick={vm.onDeleteRecordsClick}
                disabled={vm.busyWatcher.isBusy}
                variant="danger"
                className="rounded"
                size="sm">
                {vm.translate("deleteRecords")}
              </Button>
            </div>
          </div>
        )}
        <Form.Group as={Col} md={6} lg={4}>
          <FormLabel required={true}>{vm.translate("distributorId")}</FormLabel>
          <AdvancedSelect
            target={vm.filter}
            property="distributorId"
            items={vm.distributorOptions}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4}>
          <FormLabel required={true}>{vm.translate("distributorPaymentRequest")}</FormLabel>
          <AdvancedSelect
            target={vm.filter}
            property="paymentRequestId"
            items={vm.paymentRequestOptions}
            placeholder={translateGeneral("all")}
          />
        </Form.Group>
      </div>
      {vm.distributorHasNoPaymentRequests && (
        <Alert variant="warning" className="border-0">
          {vm.translate("noDistributorPaymentRequestAvailable")}
        </Alert>
      )}
    </FilterView>
  );
});

export default DistributorRefundsFilter;
